import { types, actions } from './requests'
export const DELETEMATERIAL_TYPES = {
    ...types('DELETEMATERIAL'),
}
export const DELETEMATERIAL_ACTIONS = {
    ...actions('DELETEMATERIAL'),
}